import * as _ from 'lodash';

import { ActionType, ActionTypes, State } from './types';

const FIRST_PAGE = 1;
const INITIAL_TOTAL_ITEMS = 0;

const initialState = {
  isLoading: false,
  error: '',
  items: [],
  totalItems: INITIAL_TOTAL_ITEMS,
  page: FIRST_PAGE,
  details: {
    isLoading: false,
    error: '',
    data: undefined,
  },
  selected: undefined,
  retailerPromotionOrder: [],
};

const promotionsReducer = (state: State = initialState, action: ActionType): State => {
  switch (action.type) {
    case ActionTypes.FETCH_PROMOTIONS_START:
      return {
        ...state,
        isLoading: true,
      };
    case ActionTypes.FETCH_PROMOTIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        items: _.uniqBy([...state.items, ...action.payload], 'id'),
        totalItems: action.totalItems,
      };
    case ActionTypes.ADD_SELECTED_PROMOTION:
      return {
        ...state,
        items: _.uniqBy([...state.items, action.payload], 'id'),
      };
    case ActionTypes.FETCH_PROMOTIONS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case ActionTypes.CHANGE_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case ActionTypes.SET_SELECTED_PROMOTION:
      return {
        ...state,
        selected: action.payload,
      };
    case ActionTypes.SET_PROMOTION_RETAILER:
      return {
        ...state,
        retailerPromotionOrder: action.payload,
      };
    case ActionTypes.CLEAR_PROMOTIONS:
      return {
        ...state,
        items: [],
        page: FIRST_PAGE,
        totalItems: INITIAL_TOTAL_ITEMS,
      };
    case ActionTypes.RESET_PROMOTIONS_STATE:
      return initialState;
    default:
      return state;
  }
};

export default promotionsReducer;
